import { INotificationMessage } from "@fl/shared/src/types/messages";
import {
  ArquivosAttributes,
  filesExtension,
} from "@fl/shared/src/types/models/suporte_fl/arquivos";
import { IDataExcel, IDataPDF } from "@fl/shared/src/types/reports";
import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import ApiArquivos from "../../services/suporte/auth/arquivos";
import ApiReports from "../../services/suporte/auth/reports";

interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setMessagesExport?: (item: INotificationMessage[]) => void;
  getExportDataPDF: (data?: any) => IDataPDF;
  getExportDataExcel: (data?: any) => IDataExcel;
  reportName: string;
  exportButtonTitle?: string;
}

const ButtonGenerateReport: React.FC<IProps> = ({
  setLoading,
  setMessagesExport,
  getExportDataPDF,
  getExportDataExcel,
  reportName,
  exportButtonTitle = "Exportar",
}) => {
  const exportReport = async (extension: filesExtension) => {
    try {
      setLoading?.(true);
      const dataPDF =
        extension === "pdf" ? getExportDataPDF() : getExportDataExcel();
      const result = await new ApiReports({
        data: dataPDF,
        descr: reportName,
      }).export(extension);

      if (result.success) {
        const report = result.data as ArquivosAttributes;
        const resDownload = await new ApiArquivos().download(
          "relatorios",
          report.id_arquivo || 0
        );

        if (resDownload.success) {
          if (extension === "pdf") {
            const file = new Blob([resDownload.data], {
              type: "application/pdf",
            });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, "_blank");
          } else if (extension === "xlsx") {
            const file = new Blob([resDownload.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const fileURL = URL.createObjectURL(file);

            const a = document.createElement("a");
            a.href = fileURL;
            a.download = report.arquivo;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(fileURL);
          }
        }
      }
      if (result.message) setMessagesExport?.(result.message);
    } finally {
      setLoading?.(false);
    }
  };

  return (
    <div className="text-end">
      <DropdownButton
        variant="outline-primary"
        title={exportButtonTitle}
        id="bg-nested-dropdown"
      >
        <Dropdown.Item eventKey="1" onClick={() => exportReport("pdf")}>
          PDF
        </Dropdown.Item>
        <Dropdown.Item eventKey="2" onClick={() => exportReport("xlsx")}>
          Excel
        </Dropdown.Item>
      </DropdownButton>
    </div>
  );
};

export default ButtonGenerateReport;
